import React from 'react'
import styled from 'styled-components'
import { withRouter } from '../../../../../withRouter'
import { history } from '../../../../../store'

import { colors } from '@lmc/common/constants'
import { hexToRgbA } from '../../../../../common/utils'
import { ProfileBadge } from '../../../../../components/generic'

interface Medication {
  controlledDrug?: boolean
  deleted?: boolean
  id: string
  PRN?: boolean
  resident: string
}

interface MARChartMedicationCellProps {
  medication: Medication
  name: string
  testId?: string
}

export function MARChartMedicationCell(props: MARChartMedicationCellProps) {
  const {
    medication: { controlledDrug, deleted, id, PRN, resident },
    name,
    testId
  } = props

  return (
    <MedicationCellContainer
      $deleted={deleted}
      onClick={() => history.push(`/residents/${resident}/emar/${id}/chart`)}
      data-testid={
        testId ? `${testId}-mar-medication-cell` : 'mar-medication-cell'
      }
    >
      {name}
      {!deleted && controlledDrug && (
        <ProfileBadge
          backgroundColor={hexToRgbA(colors.red, 0.2)}
          badgeStyle={badgeStyle}
          badgeText="CD"
          textColor={colors.red}
        />
      )}
      {!deleted && PRN && (
        <ProfileBadge
          backgroundColor={hexToRgbA(colors.blue, 0.2)}
          badgeStyle={badgeStyle}
          badgeText="PRN"
          textColor={colors.blue}
        />
      )}
      {deleted && (
        <ProfileBadge
          backgroundColor={hexToRgbA(colors.darkgrey, 0.2)}
          badgeStyle={badgeStyle}
          badgeText="Discontinued"
          textColor={colors.darkgrey}
        />
      )}
    </MedicationCellContainer>
  )
}

const MedicationCellContainer = styled.div<{ $deleted?: boolean }>`
  display: flex;
  padding-left: 12px;
  color: ${(props) => (props.$deleted ? colors.grey : 'inherit')};

  &:hover {
    cursor: pointer;
    color: ${colors.primary};
  }
`

const badgeStyle: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 'bold',
  marginLeft: 8,
  padding: '3px 12px',
  borderRadius: 15
}

export default withRouter(MARChartMedicationCell)
